export default __webpack_public_path__ + "static/media/1.60e8fdf8.jpg";